import { formatDateTimeLabel } from "@iq/models";

const MARKER_HOURS = Array.from({ length: 13 }, (_, index) => index * 2);

function toStandardHourLabel(hour24) {
	const normalizedHour = hour24 % 24;
	const suffix = normalizedHour >= 12 ? "PM" : "AM";
	const hour12 = normalizedHour % 12 === 0 ? 12 : normalizedHour % 12;
	return `${hour12} ${suffix}`;
}

function TimeClockDayTimeline({ rows, focusDate }) {
	const timelineRows = Array.isArray(rows) ? rows : [];

	return (
		<section className="admin-time-clock-card" aria-label="Daily work timeline">
			<h3>Daily Timeline</h3>
			<p className="admin-time-clock-muted">Focus day: {focusDate || "-"}</p>
			<div className="admin-time-clock-timeline-grid">
				<div className="admin-time-clock-timeline-row admin-time-clock-timeline-row--markers" aria-hidden="true">
					<div className="admin-time-clock-timeline-user" />
					<div className="admin-time-clock-track-markers">
						{MARKER_HOURS.map((hour) => (
							<span
								key={hour}
								className="admin-time-clock-marker-label"
								style={{ left: `${(hour / 24) * 100}%` }}
							>
								{toStandardHourLabel(hour)}
							</span>
						))}
					</div>
				</div>

				{timelineRows.length === 0 ? (
					<div className="admin-time-clock-empty">No timeline data for selected filters.</div>
				) : (
					timelineRows.map((row) => (
						<div key={row.userId} className="admin-time-clock-timeline-row">
							<div className="admin-time-clock-timeline-user">{row.userName}</div>
							<div className="admin-time-clock-timeline-track">
								{row.sessions.length === 0 ? (
									<span className="admin-time-clock-no-sessions">No sessions</span>
								) : (
									row.sessions.map((session) => (
										<div
											key={session.id}
											className={`admin-time-clock-bar${session.isOpen ? " open" : ""}`}
											style={{
												left: `${session.leftPercent}%`,
												width: `${Math.max(session.widthPercent, 0.6)}%`,
											}}
											title={`${formatDateTimeLabel(session.clockInAt)} - ${
												session.clockOutAt ? formatDateTimeLabel(session.clockOutAt) : "Open"
											} | ${session.durationLabel}${session.workedOn ? ` | ${session.workedOn}` : ""}`}
										/>
									))
								)}
							</div>
						</div>
					))
				)}
			</div>
		</section>
	);
}

export default TimeClockDayTimeline;
